/**
 * 区分 priceChangeType（contract_price_histories.price_change_type）
 * 出典：02 D-090
 */
export const PRICE_CHANGE_TYPE_VALUES = ['initial', 'sales', 'supplier', 'both'] as const;

export type PriceChangeType = (typeof PRICE_CHANGE_TYPE_VALUES)[number];

/** 285：契約を作ったときの単価の行（旧の「初回登録」）。単価変更の回数には数えない */
export const INITIAL_PRICE_CHANGE_TYPE = 'initial' satisfies PriceChangeType;

export const PRICE_CHANGE_TYPE_LABELS: Readonly<Record<PriceChangeType, string>> = {
  initial: '初回登録',
  sales: '販売単価',
  supplier: '仕入単価',
  both: '両方',
};
